<template>
  <el-dialog class="lottery-history dialog-base" :class="{ 'mobile-edit': editing && $store.getters.isMobile }" :width="$store.getters.isMobile ? mobileWidth : '520px'" :visible.sync="visible" :modal="!editing">
    <div>
      <rich-text v-model="model.historyTitle" :editing="editing" />
      <div class="lottery-history__content mt-5">
        <div ref="listContainer" v-scroll-shadow class="list">
          <div v-for="(item, index) in list" :key="index" class="item flex items-center justify-between">
            <div class="flex items-center">
              <span class="mr-4 flex-shink-0">{{ index + 1 }}</span>
              <template v-if="!['-1', -1].includes(item.gift_goods_id)">
                <div
                  class="prop-icon"
                  :class="{ 'has-level': !!item.level_icon }"
                  :style="item.level_icon ? { '--level-bg': `url('${item.level_icon}')` } : null">
                  <img :src="item.gift_goods_logo" alt="">
                </div>
                <i class="el-icon-close" />
                <span>{{ item.num }}</span>
              </template>
              <span v-else class="miss-text">{{ $t('siteBuild.lotteryWidget.noPrize') }}</span>
            </div>
            <div class="time">
              <span class="ml-2">{{ item.lottery_time }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { Dialog } from 'element-ui'
import { mapState } from 'vuex'
import scrollShadow from '../common/scrollShadow'
import { formatZoneTime } from '~/utils'
import RichText from "~/components/richText/index.vue";

export default {
  components: {
    RichText,
    [Dialog.name]: Dialog
  },
  directives: {
    scrollShadow
  },
  props: {
    editing: {
      type: Boolean,
      default: false
    },
    model: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      list: [],
      visible: false
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.siteUserInfo,
      projectId: (state) => state.project.projectId,
    }),
    bizId() {
      return this.model.bizId
    },
    chainId() {
      return this.model.chainId
    },
    mobileWidth() {
      return (this.editing && this.$store.getters.isMobile) ? '320px' : '90%'
    }
  },
  methods: {
    async init() {
      await this.getHistory()
      this.visible = true
      await this.$nextTick()
    },
    async resolveChainActivityId() {
      if (!this.chainId) {
        return this.bizId
      }
      const params = {
        project_id: this.projectId || this.userInfo.project_id || '',
        chain_id: this.chainId
      }
      const [err, res] = await this.$utils.to(this.$api.activity.getActivityList(params))
      if (!err && res?.list?.[0]?.biz_id) {
        return res.list[0].biz_id
      }
      return null
    },
    async getHistory() {
      if (this.editing) return
      const activityId = await this.resolveChainActivityId()
      if (!activityId) return
      const params = {
        activity_id: activityId,
        page_no: 1,
        page_size: 1000
      }
      const [err, res] = await this.$utils.to(this.$api.activity.historyList(params))
      if (!err && res.list) {
        this.list = res.list.map(item => {
          const newItem = {...item}
          newItem.lottery_time = formatZoneTime(newItem.lottery_time * 1000).text
          return newItem
        })
      }
    }
  }
}
</script>


<style lang="less">
@import '../common/dialogBase.less';
.lottery-history {
  .rich-text.focus-editor .ql-container.ql-snow {
    background-color: transparent;
  }
  .el-dialog__header {
    padding: 0 !important;
  }
  &.mobile-edit {
    .el-dialog {
      left: 10px;
    }
  }
  &__content {
    position: relative;
    &:before,
    &:after {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      height: 16px;
      pointer-events: none;
      opacity: 0;
      transition: opacity .2s ease;
      z-index: 10;
    }
    &:before {
      top: 0;
      background: linear-gradient(180deg, rgba(17,17,17,0.12) 0%, rgba(17,17,17,0) 100%);
    }
    &:after {
      bottom: 0;
      background: linear-gradient(0deg, rgba(17,17,17,0.12) 0%, rgba(17,17,17,0) 100%);
    }
    &.has-top-shadow:before { opacity: 1; }
    &.has-bottom-shadow:after { opacity: 1; }
    padding-top: 4px;
    .list {
      max-height: 400px;
      overflow-y: auto;
      display: flex;
      flex-direction: column;
      gap: 8px;
      padding-right: 4px;
      &::-webkit-scrollbar { width: 6px; height: 6px; }
      &::-webkit-scrollbar-thumb { background: rgba(0,0,0,0.15); border-radius: 6px; }
      .item {
        background-color: #fff;
        border: 1px solid #EFEFEF;
        border-radius: 12px;
        padding: 12px 14px;
        font-size: 12px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
        .flex { gap: 8px; }
        img { border-radius: 8px; }
        .prop-icon {
          position: relative;
          width: 40px;
          height: 40px;
          flex-shrink: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
            border-radius: 8px;
          }
          &.has-level {
            background: var(--level-bg) no-repeat;
            background-size: 100% 100%;
            img {
              width: 80%;
              height: 80%;
              border-radius: 0;
            }
          }
        }
        .el-icon-close { color: #8C8C8C; }
        .miss-text { color: #8C8C8C; font-size: 14px; }
        .time { color: #666; font-size: 12px; }
        .flex span:first-child {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 24px;
          height: 24px;
          border-radius: 50%;
          background: #F0F0F5;
          font-weight: 600;
        }
      }
    }
  }
  &.mobile-edit {
    .lottery-history__content {
      .list {
        .item {
          border-radius: 10px;
          padding: 10px 12px;
        }
      }
    }
  }
}
</style>
